import apiClient from './client';

export interface User {
  id: string;
  email: string;
  username?: string;
  role: 'admin' | 'user';
  created_at?: string;
}

export interface AuthResponse {
  token: string;
  user: User;
}

export interface RegisterRequest {
  email: string;
  password: string;
  username?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export const authApi = {
  async register(data: RegisterRequest): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/auth/register', data);
    // Store token in localStorage
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      // Update API client to use token
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
    }
    return response.data;
  },

  async login(data: LoginRequest): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/auth/login', data);
    // Store token in localStorage
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      // Update API client to use token
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
    }
    return response.data;
  },

  async getMe(): Promise<{ user: User }> {
    const response = await apiClient.get<{ user: User; token?: string }>('/auth/me');
    // If the server returned a refreshed token (e.g. role changed), update it
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
    }
    return response.data;
  },

  logout(): void {
    localStorage.removeItem('authToken');
    delete apiClient.defaults.headers.common['Authorization'];
  },

  getToken(): string | null {
    return localStorage.getItem('authToken');
  },

  setToken(token: string): void {
    localStorage.setItem('authToken', token);
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  },
};

// Initialize token from localStorage on import
const token = authApi.getToken();
if (token) {
  apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}



